import { HEROKU_URL, API_URL, URL_REGEX, MOCK_URL } from "@/consts/api.consts";

export default config => {
  let appUrl = "";
  const newConfig = config;
  const isBackend = location.search.indexOf("backend=") !== -1;
  const isMock = location.search.indexOf("mocks") !== -1;
  const isHerokuMock = location.search.indexOf("mocks-heroku") !== -1;
  const isTranslationsUrl = newConfig.url.indexOf("interfacestrings/") !== -1;

  if (isBackend && !isMock && !isHerokuMock) {
    const url = location.search.split("backend=");
    if (url.length > 1) {
      const decoded = decodeURI(url[1].split("&")[0]).replace(/"/g, "");
      appUrl = decoded && decoded.length > 1 && URL_REGEX.test(decoded) ? decoded : API_URL;
    } else {
      appUrl = API_URL;
    }
  } else {
    appUrl = API_URL;
  }

  if (isHerokuMock && !isTranslationsUrl) {
    newConfig.baseURL = newConfig.mock === "heroku" ? HEROKU_URL : MOCK_URL;
  } else if (isMock && !isTranslationsUrl) {
    newConfig.baseURL = MOCK_URL;
  } else {
    newConfig.baseURL = appUrl;
  }
  return newConfig;
};
